export default {
	persistence: {
		type: "default"
	}
};